import { ProductPricingDTO } from './price'

type CompanyReturnPriceValidationErrorKeys =
    | 'TurnoverCategory'
    | 'TransactionCountCategory'
    | 'IsVatRegistered'
    | 'BookkeepingMethod'

export const CompanyReturnPriceValidationErrors: Record<CompanyReturnPriceValidationErrorKeys, string> = {
    TurnoverCategory: 'Company turnover was not specified', // Server message was -> "Field 'TurnoverCategory' is required"
    TransactionCountCategory: 'Amount of transactions was not specified',
    IsVatRegistered: 'VAT registration status was not specified',
    BookkeepingMethod: 'Bookkeeping method was not specified',
} as const

type ValidationError<T = string> = {
    key: T | null
    value: string | null
}

export interface CompanyReturnPriceDTO extends ProductPricingDTO {
    validationErrors: ValidationError<CompanyReturnPriceValidationErrorKeys>[] | null
}
